import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class PromotionsService extends StoryblokService {
  constructor() {
    super();
    let folder = process.env.NEXT_PUBLIC_STORYBLOK_PROMOTIONS_FOLDER;
    this.baseURL += "/".concat(folder);
  }
  async getPromotionsBySegmentId(id) {
    if (!id || id <= 0) {
      console.log("Invalid segment ID. Must be a positive number.");
    }
    try {
      return await this.getStoryblokData("".concat(this.baseURL, "/by_segment_id/").concat(id));
    } catch (error) {
      console.log("Failed to fetch promotions for segment: ".concat(error.message));
      return [];
    }
  }
  async getGeneralPromotions() {
    try {
      return await this.getStoryblokData("".concat(this.baseURL, "/general"));
    } catch (error) {
      console.log("Failed to fetch general promotions: ".concat(error.message));
      return [];
    }
  }
}
const promotionsService = new PromotionsService();
export default promotionsService;